(function (window, document) {
    'use strict';

    var notice = document.querySelector('[data-current-release-notice]');
    var surface = document.querySelector('[data-public-navigation-surface]');

    function trackFathomEvent(name) {
        if (name && window.fathom && typeof window.fathom.trackEvent === 'function') {
            try {
                window.fathom.trackEvent(name);
            } catch (error) {
                // Analytics must never interrupt the release interaction.
            }
        }
    }

    document.addEventListener('click', function (event) {
        var link = event.target.closest && event.target.closest('[data-release-platform-event]');

        if (link) {
            trackFathomEvent(link.getAttribute('data-release-platform-event'));
        }
    });

    if (!notice || !surface) {
        return;
    }

    var releaseKey = notice.getAttribute('data-release-key') || '';
    var releaseHeading = notice.getAttribute('data-release-heading') || '';
    var delaySeconds = parseInt(notice.getAttribute('data-release-delay'), 10);
    var artwork = notice.querySelector('[data-release-notice-artwork]');
    var dismiss = notice.querySelector('[data-release-notice-dismiss]');
    var discover = notice.querySelector('[data-release-notice-discover]');
    var shownStorageKey = 'ikson-release-notice-shown:' + releaseKey;
    var homeStorageKey = 'ikson-release-hero-visited:' + releaseKey;
    var timer = null;
    var hideTimer = null;
    var isPresented = false;

    if (!releaseKey || !releaseHeading || !Number.isFinite(delaySeconds) || delaySeconds < 0) {
        return;
    }

    function storageAvailable() {
        var testKey = 'ikson-release-notice-storage-test';

        try {
            window.sessionStorage.setItem(testKey, '1');
            window.sessionStorage.removeItem(testKey);
            return true;
        } catch (error) {
            return false;
        }
    }

    if (!storageAvailable()) {
        return;
    }

    function hasSessionValue(key) {
        return window.sessionStorage.getItem(key) === '1';
    }

    function setSessionValue(key) {
        window.sessionStorage.setItem(key, '1');
    }

    function currentPath() {
        return surface.getAttribute('data-public-navigation-path') || window.location.pathname;
    }

    function isEligiblePath(path) {
        return path === '/music' || /^\/track\/[^/]+\/.+/.test(path);
    }

    function matchingHomeHeroIsVisible(path) {
        var activePage;
        var heroHeading;

        if (path !== '/') {
            return false;
        }

        activePage = surface.querySelector('[data-public-navigation-page].is-public-navigation-active');
        heroHeading = activePage && activePage.querySelector('.release-hero h1');

        return heroHeading && heroHeading.textContent.trim() === releaseHeading;
    }

    function clearTimers() {
        if (timer !== null) {
            window.clearTimeout(timer);
            timer = null;
        }

        if (hideTimer !== null) {
            window.clearTimeout(hideTimer);
            hideTimer = null;
        }
    }

    function loadArtwork() {
        var source;

        if (!artwork || artwork.getAttribute('src')) {
            return;
        }

        source = artwork.getAttribute('data-src');
        if (source) {
            artwork.setAttribute('src', source);
        }
    }

    function trackEvent(action) {
        trackFathomEvent(releaseHeading + ' notice ' + action);
    }

    function concealNotice() {
        clearTimers();
        notice.classList.remove('is-visible');
        notice.setAttribute('aria-hidden', 'true');

        hideTimer = window.setTimeout(function () {
            notice.hidden = true;
            hideTimer = null;
        }, 240);
    }

    function confirmPresentation() {
        var style;

        if (notice.hidden || !notice.classList.contains('is-visible')) {
            return;
        }

        style = window.getComputedStyle(notice);
        if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) <= 0) {
            window.requestAnimationFrame(confirmPresentation);
            return;
        }

        isPresented = true;
        setSessionValue(shownStorageKey);
        trackEvent('shown');
    }

    function presentNotice() {
        timer = null;

        if (!isEligiblePath(currentPath())
            || hasSessionValue(shownStorageKey)
            || hasSessionValue(homeStorageKey)) {
            return;
        }

        notice.hidden = false;
        notice.setAttribute('aria-hidden', 'false');

        window.requestAnimationFrame(function () {
            notice.classList.add('is-visible');
            window.requestAnimationFrame(confirmPresentation);
        });
    }

    function evaluatePath() {
        var path = currentPath();

        clearTimers();

        if (matchingHomeHeroIsVisible(path)) {
            setSessionValue(homeStorageKey);
        }

        if (!isEligiblePath(path)
            || hasSessionValue(shownStorageKey)
            || hasSessionValue(homeStorageKey)) {
            if (isPresented || !notice.hidden) {
                concealNotice();
            }
            return;
        }

        loadArtwork();
        timer = window.setTimeout(presentNotice, delaySeconds * 1000);
    }

    dismiss.addEventListener('click', function () {
        if (!isPresented) {
            return;
        }

        trackEvent('dismissed');
        concealNotice();
    });

    discover.addEventListener('click', function () {
        if (isPresented) {
            trackEvent('clicked');
        }
    });

    new MutationObserver(function (mutations) {
        var pathChanged = false;

        mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'aria-busy' && surface.getAttribute('aria-busy') === 'true') {
                concealNotice();
            }

            if (mutation.attributeName === 'data-public-navigation-path') {
                pathChanged = true;
            }
        });

        if (pathChanged && surface.getAttribute('aria-busy') !== 'true') {
            isPresented = false;
            evaluatePath();
        }
    }).observe(surface, {
        attributes: true,
        attributeFilter: ['aria-busy', 'data-public-navigation-path']
    });

    evaluatePath();
})(window, document);
